export default [
  'Mother',
  'Father',
  'Sister',
  'Brother',
  'Son',
  'Daughter',
  'Cousin',
  'Wife',
  'Husband',
  'Boyfriend',
  'Girlfriend',
  'Friend',
  'Professional',
  'Client',
  'Other'
]
